import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _Questions;
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { EDUCATION_STATUS_LABELS, ELIGIBILITY, HeaderConstants, Keys, PROGRAM_PAGE_ELIGIBILITY, SaveAndExitContent } from "../Common/Constants";
export var VisitorStudentLanguage = {
  Header: {
    title: HeaderConstants.CheckYourEligibility,
    description: HeaderConstants.Description
  },
  Questions: (_Questions = {}, _defineProperty(_Questions, Keys.Application.nationality, 'What is your nationality?'), _defineProperty(_Questions, Keys.Application.stateOfResidence, 'What is your state of residence?'), _defineProperty(_Questions, Keys.Application.educationStatus, 'What is your highest level of education?'), _defineProperty(_Questions, Keys.Application.mostRecentOverallGrade, 'What is your most recent overall grade?'), _defineProperty(_Questions, Keys.Application.englishProficiencyTest, 'Have you taken any English proficiency tests?'), _defineProperty(_Questions, Keys.Application.standardizedTests, 'What standardized tests have you taken within the last 5 years?'), _Questions),
  Eligibility: {
    INELIGIBLE: ELIGIBILITY.NOT_ELIGIBLE,
    ELIGIBLE: ELIGIBILITY.ELIGIBLE,
    WITH_CONDITION: ELIGIBILITY.WITH_CONDITION,
    NO_INTAKES: ELIGIBILITY.NO_INTAKES
  },
  ProgramPageEligibility: {
    ELIGIBLE: PROGRAM_PAGE_ELIGIBILITY.ELIGIBLE,
    WITH_CONDITION: PROGRAM_PAGE_ELIGIBILITY.WITH_CONDITION,
    INELIGIBLE: PROGRAM_PAGE_ELIGIBILITY.NOT_ELIGIBLE,
    NO_INTAKES: PROGRAM_PAGE_ELIGIBILITY.NO_INTAKES,
    DEFAULT: PROGRAM_PAGE_ELIGIBILITY.DEFAULT
  },
  Responses: {
    dontHaveOption: "I don't have this",
    notYetLabel: "Not yet, but I will in the future",
    notYetHelperText: "If you haven't taken a test yet, ApplyBoard can help you take it in the future."
  },
  SaveAndExitContent: {
    WARNING: SaveAndExitContent.Warning
  },
  ResultsHeader: 'You'
};
export var getQuestion = function getQuestion(key) {
  return VisitorStudentLanguage.Questions[key];
};
export var getEducationStatusLabel = function getEducationStatusLabel(key) {
  return EDUCATION_STATUS_LABELS[key];
};
export var getEligibility = function getEligibility(eligibility) {
  return VisitorStudentLanguage.Eligibility[eligibility];
};
export var getSaveAndExitContent = function getSaveAndExitContent(state) {
  return VisitorStudentLanguage.SaveAndExitContent[state];
};